<script setup lang="ts">
defineProps({
  label: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  step: {
    type: [String, Number],
    default: '1',
  },
  min: {
    type: Number,
    default: 0,
  },
  errorMessage: String,
})

const modelValue = defineModel<number | null>()
</script>

<template>
  <label class="form-control w-full">
    <div class="label">
      <span class="label-text font-semibold">
        {{ label }}
        <span v-if="required" class="text-red-500">*</span>
      </span>
    </div>
    <input
      class="input input-bordered input-sm w-full"
      :class="{ 'border-red-500': errorMessage }"
      type="number"
      :placeholder="placeholder"
      v-model="modelValue"
      :disabled="disabled"
      :required="required"
      :min="min"
      :step="step"
    />
    <span v-if="errorMessage" class="text-red-500 text-sm mt-1">{{ errorMessage }}</span>
  </label>
</template>
